// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"aa949781","345":"8f73b2c5","710":"5871acc2"}[chunkId] + ".chunk.js";
};